import { render, staticRenderFns } from "./appStatistical.vue?vue&type=template&id=4239fcbc&scoped=true&"
import script from "./appStatistical.vue?vue&type=script&lang=js&"
export * from "./appStatistical.vue?vue&type=script&lang=js&"
import style0 from "./appStatistical.vue?vue&type=style&index=0&id=4239fcbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239fcbc",
  null
  
)

export default component.exports